import { z } from '@/libs/zod';

export const walletHistorySchema = z.object({
  skip: z.number(),
  take: z.number(),
  cpf: z.string(),
  phone: z.string(),
  type: z.string().optional(),
});

export type WalletHistory = z.infer<typeof walletHistorySchema>;
